import { c as _c } from "react/compiler-runtime";
export default function YoutubeIcon() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M45 90C69.8528 90 90 69.8528 90 45C90 20.1472 69.8528 0 45 0C20.1472 0 0 20.1472 0 45C0 69.8528 20.1472 90 45 90Z" fill="white" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <g clipPath="url(#clip0_389_2398)">{t0}<g clipPath="url(#clip1_389_2398)"><path d="M71.8337 31.2465C71.1883 28.7865 69.2937 26.8532 66.8828 26.1947C62.5127 25 45 25 45 25C45 25 27.4873 25 23.1218 26.1947C20.7109 26.8532 18.8163 28.7865 18.1709 31.2465C17 35.7008 17 45 17 45C17 45 17 54.2992 18.1709 58.7535C18.8163 61.2135 20.7109 63.1468 23.1218 63.8053C27.4873 65 45 65 45 65C45 65 62.5127 65 66.8782 63.8053C69.2891 63.1468 71.1837 61.2135 71.8291 58.7535C73 54.2992 73 45 73 45C73 45 73 35.7008 71.8291 31.2465H71.8337Z" fill="#FF0000" /><path d="M39.3992 53.5701L53.9523 45L39.3992 36.4299V53.5701Z" fill="white" /></g></g>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <clipPath id="clip0_389_2398"><rect width="90" height="90" fill="white" /></clipPath>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <svg className="tw-w-full tw-h-full tw-align-top" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">{t1}<defs>{t2}<clipPath id="clip1_389_2398"><rect width="56" height="40" fill="white" transform="translate(17 25)" /></clipPath></defs></svg>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}